import styled from 'styled-components';

export const Content = styled.div`
  background: #f9fafb;
  min-height: 100vh;
`;
